module.exports = __webpack_public_path__ + "img/1.1.4649f77f.png";